export default {
    FreightServiceType: {
        NORMAL: "Service",
        PLUS: "Add Service"
    },
    CommonStatus: {
        Active: "Active",
        InActive: "InActive"
    },
    ServiceFeeType: {
        Normal: "Normal",
        Hierarchy: "Hierarchy"
    },
    ServiceAddFeeType: {
        Normal: "Normal",
        Hierarchy: "Hierarchy",
        Min: "Min"
    },
    EmployeeType: {
        Shipper: "Shipper",
        Teller: "Teller"
    },
    LadingPaymentType: {
        Sender: "Payment Sender",
        Receiver: "Payment Receiver"
    },
    LadingPickupType: {
        Home: "Home",
        PostOffice: "PostOffice"
    },
    LadingStatus: {
        GdKhoiTao: "Khởi tạo",
        DuyetHoan: "Duyệt hoàn",
        DangHoan: "Đang hoàn",
        HoanThanhCong: "Hoàn thành công",
        Reject: "Hủy"
    }
}